import React from 'react';
import classnames from 'classnames';
import { string, node } from 'prop-types';

// eslint-disable-next-line import/no-extraneous-dependencies
import {
  MDCFloatingLabelFoundation,
} from '@material/floating-label/dist/mdc.floatingLabel';

class Label extends React.PureComponent {
  constructor(props) {
    super(props);

    this.foundation = new MDCFloatingLabelFoundation({
      addClass: className => this.inputLabel.classList.add(className),
      removeClass: className => this.inputLabel.classList.remove(className),
      getWidth: () => this.inputLabel.offsetWidth,
    });
  }

  componentDidMount() {
    this.foundation.init();
  }

  componentWillUnmount() {
    this.foundation.destroy();
  }

  // onAutoFillStart() {
  //   if (this.inputLabel) {
  //     this.inputLabel.classList.add('mdc-text-field__label--float-above');
  //   }
  // }

  render() {
    const {
      htmlFor,
      className,
      children,
    } = this.props;

    return (
      // eslint-disable-next-line jsx-a11y/label-has-for
      <label
        htmlFor={htmlFor}
        ref={(inputLabel) => {
          this.inputLabel = inputLabel;
        }}
        className={classnames(
          className,
          'mdc-floating-label',
        )}
      >
        {children}
      </label>
    );
  }
}

Label.ALIGN_LEFT = Symbol('left');
Label.ALIGN_RIGHT = Symbol('right');

Label.propTypes = {
  htmlFor: string.isRequired,
  children: node.isRequired,
};

export default Label;
